module.exports = __webpack_public_path__ + "static/img/bg_fr.0e88aca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xmasSaled-2025/bg_fr.png
// module id = Tv5R
// module chunks = 1